import { render, staticRenderFns } from "./HelpPanel.vue?vue&type=template&id=68ff0b28&"
import script from "./HelpPanel.vue?vue&type=script&lang=ts&"
export * from "./HelpPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/packages/axiom-design-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68ff0b28')) {
      api.createRecord('68ff0b28', component.options)
    } else {
      api.reload('68ff0b28', component.options)
    }
    module.hot.accept("./HelpPanel.vue?vue&type=template&id=68ff0b28&", function () {
      api.rerender('68ff0b28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/04-web-components/powerbar/components/HelpPanel/HelpPanel.vue"
export default component.exports